import { Flex, Text } from '@mantine/core';
import { IconThumbDown, IconThumbUp } from '@tabler/icons-react';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import BaseClickable from '@/components/ui/BaseClickable';
import { useOrganizationChatAiPageStore } from '@/stores/local/pages/OrganizationChatAiPageStore';
import { useDevices } from '@/utils/devices';

import s from './RatingPanel.module.scss';

type Props = {
  answerId?: string;
  className?: string;
};

const RatingPanel: React.FC<Props> = ({ answerId, className }) => {
  const { isCompactViewport } = useDevices();

  const { answerRatingStore } = useOrganizationChatAiPageStore();
  const isRateDisabled = !answerId;

  const onClick = React.useCallback(
    (rating: 'positive' | 'negative') => {
      answerRatingStore.putRate(answerId, rating);
    },
    [answerId, answerRatingStore],
  );

  const handleNegativeClick = React.useCallback(() => {
    answerRatingStore.openFeedbackModal(answerId);
  }, [answerId, answerRatingStore]);

  const wasPositiveAnswer = answerRatingStore.wasPositiveAnswer(answerId);
  const wasNegativeAnswer = answerRatingStore.wasNegativeAnswer(answerId);

  return (
    <>
      <Flex
        justify="space-between"
        gap={isCompactViewport ? 'md' : 'sm'}
        align="center"
        className={cn(s.root, className)}
      >
        <Text size={isCompactViewport ? 'xs' : 'md'} fw={isCompactViewport ? 500 : 600}>
          Оцените качество ответа
        </Text>
        <Flex gap="xs">
          <BaseClickable
            onClickWithValue={onClick}
            value="positive"
            disabled={isRateDisabled}
            className={cn(
              s.root__action,
              s.root__action_positive,
              wasPositiveAnswer && s['root__action_positive-select'],
            )}
          >
            <IconThumbUp size={16} />
          </BaseClickable>

          <BaseClickable
            onClick={handleNegativeClick}
            value="negative"
            disabled={isRateDisabled}
            className={cn(
              s.root__action,
              s.root__action_negative,
              wasNegativeAnswer && s['root__action_negative-select'],
            )}
          >
            <IconThumbDown size={16} />
          </BaseClickable>
        </Flex>
      </Flex>
    </>
  );
};

export default observer(RatingPanel);
